import React, { useRef, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import SolutionSection from "@/components/SolutionSection";
import QualificationForm from "@/components/QualificationForm";
import FAQSection from "@/components/FAQSection";
import TrustSection from "@/components/TrustSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import AdminDashboard from "@/components/AdminDashboard";
import TestimonialsSection from "@/components/TestimonialsSection";
import StatsSection from "@/components/StatsSection";
import LoanCalculator from "@/components/LoanCalculator";  // eslint-disable-line no-unused-vars
import HowItWorks from "@/components/HowItWorks";
import ConsultantProfile from "@/components/ConsultantProfile";
import DocumentChecklist from "@/components/DocumentChecklist";
import StickyBottomBar from "@/components/StickyBottomBar";
import LiveNotification from "@/components/LiveNotification";
import { captureFbclid } from "@/utils/fbTracking";

const LandingPage = () => {
  const formRef = useRef(null);

  useEffect(() => {
    // Capture fbclid from URL for Facebook attribution
    captureFbclid();
  }, []);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <HeroSection onScrollToForm={scrollToForm} />
      <QualificationForm ref={formRef} />
      <StatsSection />
      <ProblemSection />
      <HowItWorks />
      <SolutionSection />
      <ConsultantProfile />
      <TestimonialsSection />
      <DocumentChecklist />
      <TrustSection />
      <FAQSection />
      <FinalCTA />
      <Footer />
      <FloatingWhatsApp />
      <StickyBottomBar onScrollToForm={scrollToForm} />
      <LiveNotification />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
